import React from 'react';
import { Filter, ReferenceInput, SelectInput, TextInput } from 'react-admin';
import { CustomDateInput } from '../../../../commonComponents/CustomDateInput';

const SalesTipsReportsFilter = (props) => (
  <Filter {...props}>
    <TextInput label="User ID" source="user_id" alwaysOn />
    <ReferenceInput label="Sales tips" source="id" reference="admin/sales-tips" alwaysOn>
      <SelectInput optionText={(s) => `(${s.id}) ${s.name}`} />
    </ReferenceInput>
    <CustomDateInput label="Choose start date" source="start_date" start alwaysOn />
    <CustomDateInput label="Choose end date" source="end_date" end alwaysOn />
  </Filter>
);

export default SalesTipsReportsFilter;
